import { useLang } from "@/i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-extrabold uppercase tracking-wide text-white/90 sm:text-3xl">
          {item}
        </span>
        <svg width="18" height="18" viewBox="0 0 24 24" className="shrink-0">
          <path
            d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4L12 2z"
            fill="#FFC700"
          />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0B0B0F] py-6"
    >
      <div className="animate-marquee flex w-max">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#070709] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#070709] to-transparent" />
    </div>
  );
};
